const EUR = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
  maximumFractionDigits: 0,
});

const DAY = new Intl.DateTimeFormat("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
const MONTH = new Intl.DateTimeFormat("de-DE", { month: "long", year: "numeric" });
const STAMP = new Intl.DateTimeFormat("de-DE", { dateStyle: "short", timeStyle: "short" });

export const money = (cents: number): string => EUR.format(cents / 100);
export const day = (iso: string): string => DAY.format(new Date(iso));
export const month = (iso: string): string => MONTH.format(new Date(iso));
export const stamp = (iso: string): string => STAMP.format(new Date(iso));

/** Minuten als "34,9 h" -- die Einheit, in der die 45h-Regel gedacht ist. */
export const hours = (minutes: number | null): string =>
  minutes === null ? "–" : `${(minutes / 60).toFixed(1)} h`;

/**
 * Verstaendlicher Text zu einem Ablehnungsgrund.
 *
 * Die API liefert bewusst nur Codes: uebersetzt wird hier, damit der
 * Wortlaut ohne Serverneustart aenderbar bleibt.
 */
const REASONS: Record<string, string> = {
  trip_duration_ok: "Reisedauer im Rahmen",
  trip_too_short: "Reise zu kurz",
  trip_too_long: "Reise zu lang",
  return_before_departure: "Rückflug vor Abflug",
  within_max_travel_time: "Reisezeit im Rahmen",
  exceeds_max_travel_time: "Reisezeit über der Grenze",
  stopover_exemption_granted: "Stopover-Ausnahme greift",
  no_hub_layover: "Zwischenstopp an keinem gelisteten Hub",
  multiple_hub_layovers: "Zwei Zwischenstopps an Hubs – kein bewusster Stopover",
  layover_too_short: "Aufenthalt kürzer als die Mindestzeit des Hubs",
  layover_too_long: "Aufenthalt länger als zwei Tage",
  exemption_only_once: "Beide Strecken zu lang – die Ausnahme gilt nur einmal",
  savings_too_small: "Ersparnis unter der Schwelle",
  no_baseline: "Kein Vergleichspreis – Ersparnis nicht belegbar",
};

export const reasonText = (reason: string): string => REASONS[reason] ?? reason;
